/**
 * The app's page scroller (GDN-3220): AppFrame's `#root-main`.
 * The shell fills 100dvh; CSS reserves space for navigation and banners,
 * then gives this element the remaining height and explicit overflowY:auto.
 * Bounded workspace routes can opt into panel scrolling instead; their
 * panel offsets are separate from the page offset managed here.
 *
 * Every feature that reads or writes page scroll must go through here:
 * AppFrame consumes the id, so the two can't drift apart, and call sites
 * fall back to the window for contexts without the shell (tests,
 * Storybook, a future layout where the window really does scroll).
 */

export const APP_SCROLL_CONTAINER_ID = 'root-main';

export function getAppScroller(): HTMLElement | null {
  return document.getElementById(APP_SCROLL_CONTAINER_ID);
}

/** Current vertical offset of the page, wherever it actually scrolls. */
export function getAppScrollTop(): number {
  return getAppScroller()?.scrollTop ?? window.scrollY;
}

/** Scroll the page to a vertical offset, wherever it actually scrolls. */
export function scrollAppTo(top: number): void {
  const scroller = getAppScroller();
  if (scroller) {
    scroller.scrollTo({ top });
    return;
  }
  window.scrollTo({ top });
}
